import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const repairs = [
  { text: "Persianas que no suben o no bajan" },
  { text: "Cintas rotas o atascadas" },
  { text: "Lamas dañadas o desalineadas" },
  { text: "Motores estropeados" },
  { text: "Cajón de persiana descuadrado" },
  { text: "Poleas y recogedores" },
];

const steps = [
  { num: "1", title: "Llámanos o pide presupuesto online", desc: "Te respondemos en 20 min por teléfono o WhatsApp." },
  { num: "2", title: "Visita técnica gratuita en 24h", desc: "Nuestro técnico acude a tu hogar sin coste alguno." },
  { num: "3", title: "Presupuesto detallado sin compromiso", desc: "Precio claro por escrito antes de empezar." },
  { num: "4", title: "Reparación con garantía de 2 años", desc: "Trabajo hecho con piezas de calidad y garantía incluida." },
];

const faqs = [
  {
    q: "¿Cuánto cuesta reparar una persiana en Málaga?",
    a: "Depende del tipo de avería. Cambiar una cinta desde 60 €, reparar un motor desde 80 € y sustituirlo desde 150 €. Siempre damos presupuesto exacto sin compromiso tras la visita gratuita.",
  },
  {
    q: "¿Cuánto tiempo tardáis en venir?",
    a: "Normalmente visitamos en menos de 24 horas desde que nos contactas. Si es una reparación urgente, intentamos acudir el mismo día.",
  },
  {
    q: "¿Dais garantía en las reparaciones?",
    a: "Sí, todas nuestras reparaciones tienen garantía de 2 años tanto en piezas como en mano de obra. Si algo falla, volvemos sin coste.",
  },
  {
    q: "¿Trabajáis los sábados?",
    a: "Sí, atendemos reparaciones urgentes los sábados por la mañana. Llámanos y te confirmamos disponibilidad.",
  },
  {
    q: "¿Reparáis persianas eléctricas también?",
    a: "Por supuesto. Reparamos motores Somfy, Cherubini, Becker y otras marcas. También motorizamos persianas manuales.",
  },
];

export default function ReparacionPersianas() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Reparación de Persianas en Málaga | Presupuesto Gratis 24h"
        description="Reparamos tu persiana en Málaga en 24h. Motor, cinta, lamas. Presupuesto gratis sin compromiso. Garantía 2 años. ☎ 951 12 07 70"
        canonical="/persianas/reparacion-persianas-malaga/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Persianas", path: "/persianas" }, { name: "Reparación persianas Málaga" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[60%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> 24h · Respuesta en 20 min
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Reparación de Persianas en Málaga
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Servicio rápido en 24-48h. Reparamos todos los modelos: aluminio, PVC, eléctricas, mallorquinas.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
              </div>
              <div className="w-full lg:w-[40%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://storage.readdy-site.link/project_files/cf1847c3-949c-4dd2-b2c0-64bc50d47abe/519deffd-e61d-4fba-b652-d73da5617821_volet-roulant-genappe.jpg?v=6245ce0e67464e00ebf3cb7475bd0a3b"
                    alt="Reparación de persianas en Málaga - técnico trabajando"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ¿QUÉ REPARAMOS? */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">¿Qué reparamos?</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-4xl mx-auto">
              {repairs.map((r, i) => (
                <motion.div
                  key={r.text}
                  className="flex items-center gap-3 bg-white rounded-2xl px-6 py-5 shadow-sm"
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                >
                  <span className="flex items-center justify-center w-8 h-8 bg-primary/10 text-primary rounded-full shrink-0 font-bold text-sm">✓</span>
                  <span className="font-body text-base text-text-primary">{r.text}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* PROCESO 4 STEPS */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Nuestro proceso</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {steps.map((s, i) => (
                <motion.div
                  key={s.num}
                  className="relative text-center"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center font-heading font-extrabold text-2xl mx-auto mb-4">
                    {s.num}
                  </div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-2">{s.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{s.desc}</p>
                  {i < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-8 left-[calc(50%+2rem)] right-[-50%] h-0.5 bg-border"></div>
                  )}
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto" itemScope itemType="https://schema.org/FAQPage">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Preguntas frecuentes</h2>
              <div className="flex flex-col gap-4">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-white rounded-2xl p-6 shadow-sm"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}